var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('v-row',{staticClass:"bg pa-0 ma-0 fill-height align-content-center"},[_c('v-col',[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.$store.state.logo,"alt":"Praxair_logo"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$store.state.introText)}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }